import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

export class OAuthCallBack extends React.Component {
  static propTypes = {
    session: PropTypes.shape({
      isAuthenticated: PropTypes.bool.isRequired,
      status: PropTypes.string.isRequired,
      device: PropTypes.object,
    }).isRequired,
    networkError: PropTypes.bool.isRequired,
    provider: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { code } = this.props.location.query;
    const { provider } = this.props;

    if (!code) {
      window.opener.postMessage({
        type: 'OAUTH_CODE_ERROR',
        message: 'Couldn\'t fetch account details. Try again later or another way.',
      }, window.location.origin);
      window.close();
      return;
    }

    window.opener.postMessage({
      type: 'OAUTH_CODE_RECEIVED',
      code,
      provider
    }, window.location.origin);
    window.close();
  }


  render() {
    return (
      <div>
        <Helmet>
          <title>Authenticating with {this.props.provider}</title>
        </Helmet>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/OAuthCallBack.jsx